import React, {useState, useEffect} from "react";
import GenericTemplate from "../../templates/GenericTemplate";
import {
  apollo_useStyles,
  options_extension_manual,
  options_manualType,
  valueToOption,
} from "../../atom/Apollo_styles";
import {MUISortOptions} from "mui-datatables";
import {APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN, ApolloUserProfileAuth} from "../../atom/Apollo_Authorization";
import {CustomizedSnackbars} from "../../atom/Apollo_Mesasge"
import {ApolloDataTable, STORAGE_KEY} from "../../atom/Apollo_DataTable";
import {ApiResponse, ApolloAxios, getResultType, isSuccessApi} from "../../atom/Apollo_ApiRequest3";
import {ApolloMessage} from "../../atom/Apollo_Mesasge";
import {ApolloContext} from "../../atom/Apollo_Context";
// メッセージ定義
import {
  GetMessage, UI_MANUAL_LIST,
} from "../../atom/Apollo_MesasgeDefinition";

import {Card, Button, Backdrop} from '@material-ui/core';
import {Manual} from "./ManualModel";
import ApolloManualUploadModal from "../../organism/MANUAL/Apollo_ManualUploadModal";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../atom/Apollo_Breadcrumbs2";
import {apollo_manuals_path} from "../../atom/Apollo_links";
import {Bars} from "react-loader-spinner";
import moment from "moment";
import {ApolloDialog} from "../../atom/Apollo_Dialog";
import {APOLLO_PAGE_ID} from "../../common/Apollo_LocalStorageSettings";

/*
    画面名：業種マスタ一覧画面
 */
export default function ManualPage() {
  const classes = apollo_useStyles();
  const [open, setOpen] = useState(false);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const {state: apolloContex} = React.useContext(ApolloContext);
  const [tableData, setTableData] = useState<Manual[]>([]);
  const [updateListCnt, setUpdateListCnt] = useState<number>(0);
  const [progress, setProgress] = useState(true);
  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 21,
    breadId: 1,
    queries: [],
    menu: {
      id: 0,
      accountId: "",
      accountName: "",
    },
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  const [manual, setManual] = useState<Manual>({
    manualType: 0,
    name: "",
    mimeType: 0,
    modifiedAt: "",
  });

  const [sortOrder, setSortOrder] = useState<MUISortOptions>({
    name: "category",
    direction: 'asc',
  })
  const [numberOfRows, setNumberOfRows] = useState(10)

  useEffect(() => {
    setProgress(true);
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    });

    // マニュアル一覧を取得
    const url = apollo_manuals_path;
    ApolloAxios.get(url).then(response => {
      const res: ApiResponse = response.data;
      if (!isSuccessApi(res.resultCode)) {
        return Promise.reject({
          open: true,
          type: getResultType(res.resultCode),
          errmsg: res?.message ? res.message : GetMessage("0", UI_MANUAL_LIST, "E", "0"),
        });
      }
      setTableData(res.result);
    }).catch(err => {
      setmsg({
        type: "all",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: GetMessage("0", UI_MANUAL_LIST, "E", "0"),
          loading: false,
        }
      });
    }).finally(() => {
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: false,
        }
      });
      setProgress(false);
    });
  }, [updateListCnt]);

  // リストカラム定義
  const columns = [
    {
      name: "manualType",
      label: "カテゴリ",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          return valueToOption(value, options_manualType).label;
        },
      }
    },
    {
      name: "name",
      label: "ファイル名",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "mimeType",
      label: "拡張子",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          return valueToOption(value, options_extension_manual).label;
        },
      }
    },
    {
      name: "modifiedAt",
      label: "最終更新日時",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: string) => `${moment(value).format('YYYY/MM/DD HH:mm:ss')}`,
      }
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        options: {
          setCellProps: () => ({
            align: "center"
          }),
        },
        customBodyRenderLite: (idx: number) => {
          return (
            <Button
              className={classes.buttonTop}
              variant={"contained"}
              color={"primary"}
              onClick={() => handleClickUpdateOpen(idx)}
            >
              更新
            </Button>
          );
        },
      },
    },
  ];

  // 更新ボタンハンドラ
  const handleClickUpdateOpen = (idx: number) => {
    const manualType = tableData[idx]?.manualType
    const manualData = tableData.find(tableData => tableData.manualType === manualType);
    if (!manualData) {
      setmsg({
        type: "all",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: GetMessage("0", UI_MANUAL_LIST, "E", "0"),
          loading: false,
        }
      });
      return;
    }
    setManual(manualData);
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const listReloadFunc = () => {
    setUpdateListCnt(updateListCnt + 1)
    setOpen(false);
  };

  // データリスト表示オプション
  const options = {
    filter: true,
    download: false,
    print: false,
    sort: true,
    sortOrder: localStorage.getItem(STORAGE_KEY.MASTER_INDUSTORYS) ? undefined : sortOrder,
    selectableRows: 'none',
    rowsPerPage: numberOfRows,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    storageKey: STORAGE_KEY.MASTER_INDUSTORYS,
    apolloPageId: APOLLO_PAGE_ID.MANUAL_LIST,
    onColumnSortChange: (changedColumn: string, direction: string) => {
      setSortOrder({
        name: changedColumn,
        direction: direction,
      } as MUISortOptions)
    },
    onChangeRowsPerPage: (numberOfRows: number) => setNumberOfRows(numberOfRows),
  }

  // 画面表示
  return (
    <GenericTemplate title="">
      <Backdrop className={classes.backdrop2} open={progress}>
        <Bars color="#00BFFF" height={80} width={80}/>
      </Backdrop>
      <ApolloUserProfileAuth role={APOLLO_SYSTEM_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
        <ApolloBreadcrumbs2 data={breadcrumbsData}/>

        <Card className={classes.root} square variant="outlined">
          <ApolloDataTable
            title=""
            data={tableData}
            columns={columns}
            options={
              {
                ...options,
                textLabels: {
                  body: {noMatch: "該当データが存在しません"}
                },
              }
            }
          />
        </Card>

        {/* ダイアログ表示 */}
        <ApolloDialog open={open} setOpen={setOpen} onClose={handleClose}>
          <ApolloManualUploadModal manual={manual} setOpen={setOpen} listReloadFunc={listReloadFunc}/>
        </ApolloDialog>

      </ApolloUserProfileAuth>
      {/* メッセージ表示 */}
      <CustomizedSnackbars/>
    </GenericTemplate>
  );
};
